import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/runs/:runId");

export const Route = createFileRoute("/runs/$runId")({
  head: () => ({
    meta: [
      { title: "Run detail — LevelLoad" },
      { name: "description", content: "Run detail — LevelLoad transport planning." },
      { property: "og:title", content: "Run detail — LevelLoad" },
      { property: "og:description", content: "Run detail — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
